import { getGlobalSettingsAccountMailboxInfo } from "owa-account-source-list-store";
import { logUsage } from "owa-analytics";
import type { MailboxInfo } from "owa-client-types";
import { isConsumer } from "owa-session-store";
import type AccessIssue from "../schema/AccessIssue";
import getAttachmentPolicyBasedOnFlag from "./getAttachmentPolicyBasedOnFlag";
import getUserConfiguration from "owa-session-store/lib/actions/getUserConfiguration";

/**
 * Those fields combine both conditional access and attachment policy
 * the logic is on the server code
 */
export default function getCombinedAccessIssue(mailboxInfo: MailboxInfo): AccessIssue {
    let attachmentPolicy = getAttachmentPolicyBasedOnFlag(mailboxInfo);
    if (!attachmentPolicy) {
        logUsage("AttachmentPolicyUndefinedForAccessIssue", mailboxInfo);
        attachmentPolicy = getAttachmentPolicyBasedOnFlag(getGlobalSettingsAccountMailboxInfo());
        if (!attachmentPolicy) {
            const isConsumerUser = isConsumer(undefined /* smtpAddress */, mailboxInfo);
            logUsage("AttachmentPolicyUndefinedForAccessIssueWithFallback", mailboxInfo, {
                isConsumerUser,
            });
            if (isConsumerUser) {
                return 2;
            }
            return 1;
        }
    }
    const userConfiguration = getUserConfiguration();
    const shouldTreatAsPublicLogon: boolean = !!userConfiguration.SessionSettings?.IsPublicLogon ||
        !!(userConfiguration.PublicComputersDetectionEnabled &&
            userConfiguration.SessionSettings?.IsPublicComputerSession);
    
    if (!attachmentPolicy.DirectFileAccessOnPrivateComputersEnabled ||
        (shouldTreatAsPublicLogon && !attachmentPolicy.DirectFileAccessOnPublicComputersEnabled)) {
        if (!attachmentPolicy.WacViewingOnPrivateComputersEnabled ||
            (shouldTreatAsPublicLogon && !attachmentPolicy.WacViewingOnPublicComputersEnabled)) {
            return 1;
        }
        else {
            return 0;
        }
    }
    return 2;
}
